module.exports = "//img1.rrcimg.com/_next/static/src/assets/package_2odMw.png";